import React from 'react';
import PropTypes from 'prop-types';

import Map from '@strava/ui/Map';
import PolygonCircle from '@strava/ui/Map/PolygonCircle';
import Popup from '@strava/ui/Map/Popup';
import SvgActionsVisibleDisabledNormalXsmall from '@strava/icons/ActionsVisibleDisabledNormalXsmall';
import styles from './styles.scss';

const { MAPBOX_TOKEN } = process.env;

function PrivateLocationMap({ privateLocation }) {
  const setZoom = () => {
    let zoom;
    if (privateLocation.radius > 800) {
      zoom = 11;
    } else if (privateLocation.radius > 400) {
      zoom = 12;
    } else if (privateLocation.radius > 200) {
      zoom = 13;
    } else {
      zoom = 14;
    }
    return zoom;
  };

  return (
    <Map
      APIToken={MAPBOX_TOKEN}
      options={{
        center: [privateLocation.position.lng, privateLocation.position.lat],
        zoom: setZoom()
      }}
      attributionControl={true}
      className={styles.map}
    >
      <PolygonCircle
        id={privateLocation.id}
        lat={privateLocation.position.lat}
        lng={privateLocation.position.lng}
        // radius is in meters and we need to convert it to kilometers
        radius={privateLocation.radius / 1000}
        style={{
          fillColor: '#B2AFC0',
          fillOpacity: 0.7,
          strokeWeight: 0
        }}
      />
      <Popup
        latLng={[
          privateLocation.original_position.lat,
          privateLocation.original_position.lng
        ]}
        closeButton={false}
        className={styles.popup}
        id={privateLocation.id}
      >
        <SvgActionsVisibleDisabledNormalXsmall fill="#fff" />
      </Popup>
    </Map>
  );
}

PrivateLocationMap.propTypes = {
  privateLocation: PropTypes.shape({
    id: PropTypes.string,
    address: PropTypes.string,
    position: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    }),
    original_position: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    }),
    radius: PropTypes.number,
    repositionRateLimited: PropTypes.bool,
    regeneratePrivateLocationPath: PropTypes.string,
    deletePrivateLocationPath: PropTypes.string,
    distanceHidden: PropTypes.shape({
      label_key: PropTypes.string,
      value: PropTypes.string
    })
  }).isRequired
};

export default PrivateLocationMap;
